<ng-container *ngFor="let option of field.options">
  <label for="option.name">{{option.label}}</label>
  <input type="radio" [disabled]="disabled" [id]="option.name" [value]="option.value" [ngModel]="value" (ngModelChange)="writeValue($event)" name="{{field.name}}" />
</ng-container>

